import request from '@/axios/request.js'

// 创建账号
export function registerID (data) {
    // {
    //     "account": "", 手机号码
    //     "captcha": "", 验证码
    //     "inviteCode": "", 邀请码
    //     "password": "", 密码
    //     "spread": "" 分销绑定关系的ID
    // }
    return request({
        url: '/api/register',
        method: 'post',
        data
    })
}
export function getVerify (data) {
    // {
    //     "phone": "", 手机号码
    //     "type": "" 短信类型 bind绑定手机短信 login登陆短信 register注册短信
    // }
    return request({
        url: '/api/register/verify',
        method: 'post',
        data
    })
}
export function getResetPwdSend (data) {
    // {
    //     "phone": "", 手机号码
    //     "type": "" 短信类型 bind绑定手机短信 login登陆短信 register注册短信
    // }
    return request({
        url: '/api/resetPwdSend',
        method: 'post',
        data
    })
}
export function getResetPwdSendConfirm (data) {
    return request({
        url: '/api/resetPwdSend-confirm',
        method: 'post',
        data
    })
}
export function addBaseLogin (data) {
    return request({
        url: '/api/base/login',
        method: 'post',
        data
    })
}

// H5登录授权
export function loginWeb (data) {
    // {
    //     "password": "",必填
    //     "spread": "",
    //     "username": ""
    // }
    return request({
        url: '/api/login',
        method: 'post',
        data
    })
}
export function baseLogin (data) {
    // {
    //     "password": "",必填
    //     "spread": "",
    //     "username": ""
    // }
    return request({
        url: '/api/baseLogin',
        method: 'post',
        data
    })
}
// 退出登录
export function logoutWeb () {
    return request({
        url: '/api/auth/logout',
        method: 'post'
    })
}

// 获取用户信息
export function getUserInfo () {
    return request({
        url: '/api/userinfo',
        method: 'get'
    })
}

// 修改用户信息
/**
    avatar: this.formData.avatar,
    nickname: this.formData.nickname
*/
export function editUserInfo (data) {
    return request({
        url: '/api/user/edit',
        method: 'post',
        data
    })
}

// 注册用户
export function registerSubmit (data) {
    return request({
        url: '/api/applet/distributor/register-pc',
        method: 'post',
        data
    })
}

// 注册用户
export function registerSubmitUpdate (data) {
    return request({
        url: '/api/applet/distributor/register-pc/update',
        method: 'post',
        data
    })
}

// 注册用户
export function getDistributorInfo (data) {
    return request({
        url: '/api/user/distributor-info',
        method: 'post',
        data
    })
}

// 注册用户 - 发送短信验证码
export function registerCodeResetSms (data) {
    return request({
        url: '/api/pc-shop/code/resetSms',
        method: 'post',
        data
    })
}
// 注册用户 - 验证验证码
export function registerCodeValidated (data) {
    return request({
        url: '/api/pc-shop/code/validated',
        method: 'post',
        data
    })
}
